import { useContext } from "react";

import { Input } from "antd";
import TextArea from "antd/lib/input/TextArea";

import { RVFormFloatingLabelWrap } from "@regal-voice/ui";
import { Column } from "Components/shared/Flexbox";

import { JourneyFormContext } from "../../../../../shared/Contexts/JourneyFormContext";

import styles from "./CustomTaskFormItems.module.scss";

export type CustomTaskFormItemsProps = {
    formValues?: {
        task?: { name?: string; description?: string };
    };
};

export function CustomTaskFormItems(): JSX.Element {
    const { formSubmited } = useContext(JourneyFormContext);

    return (
        <Column className={styles.container}>
            <RVFormFloatingLabelWrap
                name={["task", "name"]}
                showFormLabel
                formItemHeader="Create Custom Task"
                label="Custom Task Name"
                rules={[{ required: formSubmited, message: "Name is required." }]}
            >
                <Input maxLength={50} data-testid="custom-task-name" />
            </RVFormFloatingLabelWrap>
            <RVFormFloatingLabelWrap
                fixedFloatingLabel
                name={["task", "description"]}
                label="Custom Task Description"
                containerClassName={styles.lastFormItem}
                rules={[{ required: formSubmited, message: "Description is required." }]}
            >
                <TextArea showCount maxLength={3000} style={{ resize: "none" }} data-testid="custom-task-description" />
            </RVFormFloatingLabelWrap>
        </Column>
    );
}
